/**
 * Mobile Bottom Navigation
 * ========================
 * 
 * Navegación inferior para la app móvil.
 */

import { useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, Bot, Home, Trophy, User } from 'lucide-react';
import { useNativeApp } from '../../hooks/useNativeApp';

const navItems = [
  { path: '/dashboard', label: 'Inicio', icon: Home },
  { path: '/tests', label: 'Tests', icon: BookOpen },
  { path: '/tutor-ia', label: 'Tutor IA', icon: Bot },
  { path: '/retos', label: 'Retos', icon: Trophy },
  { path: '/profile', label: 'Perfil', icon: User },
];

export const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hapticFeedback, isNative } = useNativeApp();

  const handleNavClick = async (path) => {
    if (isNative) {
      await hapticFeedback('light');
    }
    navigate(path);
  };

  // No mostrar en ciertas rutas
  const hiddenRoutes = ['/login', '/register', '/onboarding', '/primer-dia', '/test/', '/auth'];
  if (hiddenRoutes.some(route => location.pathname.startsWith(route))) {
    return null;
  }

  // No mostrar en landing page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="mobile-bottom-nav bg-white border-t border-gray-200" role="navigation" aria-label="Main navigation">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
                          location.pathname.startsWith(item.path + '/');
          const Icon = item.icon;
          
          return (
            <button
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              aria-current={isActive ? 'page' : undefined}
              aria-label={item.label}
              className={`flex flex-col items-center justify-center flex-1 h-full touch-feedback no-select transition-colors relative ${
                isActive
                  ? 'text-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <div className={`${isActive ? 'scale-110' : ''} transition-transform`}>
                <Icon size={24} />
              </div>
              <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : ''}`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute bottom-0 w-12 h-0.5 bg-blue-600 rounded-t" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
